import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const data = [
  { month: 'Jan', winRate: 65, proposals: 25 },
  { month: 'Feb', winRate: 72, proposals: 30 },
  { month: 'Mar', winRate: 68, proposals: 28 },
  { month: 'Apr', winRate: 75, proposals: 35 },
  { month: 'May', winRate: 70, proposals: 32 },
  { month: 'Jun', winRate: 78, proposals: 40 },
];

export function BidPerformanceChart() {
  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <h3 className="text-lg font-medium text-gray-900">Bid Performance</h3>
      <div className="mt-2">
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis yAxisId="left" />
              <YAxis yAxisId="right" orientation="right" />
              <Tooltip />
              <Legend />
              <Line
                yAxisId="left"
                type="monotone"
                dataKey="winRate"
                name="Win Rate (%)"
                stroke="#8884d8"
                activeDot={{ r: 8 }}
              />
              <Line
                yAxisId="right"
                type="monotone"
                dataKey="proposals"
                name="Proposals"
                stroke="#82ca9d"
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}